<template>
    <div class="filter-tabs">
        <!-- Bootstrap's Button Group -->
        <div class="btn-group" role="group">
            <!-- Filter Items -->
            <button v-for="item in props.items" type="button" class="btn btn-light text-2"
                    :class="{active:_isItemSelected(item)}"
                    @click="_selectItem(item)">
                <!-- Item Label -->
                {{item}}
            </button>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue"

/**
 * @property {{String}[]} items
 */
const props = defineProps({
    items: Array
})

const emit = defineEmits(['selected'])
const selectedItemId = ref(null)

/**
 * @param {Object} item
 * @return {boolean}
 * @private
 */
const _isItemSelected = (item) => {
    if(selectedItemId.value === null && props.items && props.items.length > 0) {
        _selectItem(props.items[0])
    }

    return selectedItemId.value === item
}

/**
 * @param {Object} item
 * @private
 */
const _selectItem = (item) => {
    selectedItemId.value = item
    emit('selected', item)
}
</script>

<style lang="scss" scoped>
@import "/src/scss/_theming.scss";

.btn-group {
    margin: 0 auto;
    min-width: 50%;
    display: flex;
    flex-wrap: nowrap;
    @include media-breakpoint-down(lg) {
        min-width: 100%;
    }

    @include media-breakpoint-down(sm) {
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.35rem;
    }
}

.filter-tabs {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 0.2rem;

    @include media-breakpoint-down(sm) {
        text-align: center;
        overflow-x: visible;
        overflow-y: visible;
        padding-bottom: 0;
    }

    &::-webkit-scrollbar {
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: rgba($dark, 0.08);
    }

    &::-webkit-scrollbar-thumb {
        background: rgba($dark, 0.35);
        border-radius: 999px;
    }
}

.btn {
    @include generate-dynamic-styles-with-hash((
        xxxl: (padding: 0.3rem 2rem),
        sm: (padding: 0.35rem 0.9rem)
    ));

    flex: 0 0 auto;
    opacity: 0.8;
    border-radius: 30px;
    background-color: darken($light, 5%);

    @include media-breakpoint-down(sm) {
        margin: 0;
    }

    &.active, &:hover {
        background-color: darken($light, 5%);
        border-color: $light;
        color: $primary;
    }

    &.active {
        font-weight: bold;
        opacity: 1;
    }
}
</style>